import type { SortModelItem } from 'ag-grid-community';

// AG Grid 36 adds `type` to each sort item. The grid search endpoints take only the column and the direction, and the
// Bank Feed one rejects any other key with a 422, so a server-side request sends these two only.
export const toRequestSortModel = (sortModel: ReadonlyArray<SortModelItem>) =>
  sortModel.map(({ colId, sort }) => ({ colId, sort }));
